import React, { useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useQuery } from '@apollo/react-hooks';

import { reduceContent } from '../globalUtils'
import { CONTENT_BY_PAGE } from '../../graphql';
import {
    HomeContainer
} from './index.style';

import Top from './Top';
import TaxRefunds from './TaxRefunds';
import Insurance from './Insurance';
import { ClientTestimonies, Articles, Contact, Loader } from '../Generic';
import BigCompanies from './BigCompanies';
import BlogSlider from "./Blog";
const { REACT_APP_SERVER_URI: serverUri } = process.env;

const Home = () => {
    const { loading, error, data } = useQuery(CONTENT_BY_PAGE, {
        variables: {
            page: 'home',
            language: 'he',
        },
    });
    const { data: d1 } = useQuery(CONTENT_BY_PAGE, {
        variables: {
            page: 'whatsapp',
            language: 'he',
        },
    });
    // const { loading: l1, error:er1, data: d1 } = useQuery(CONTENT_BY_PAGE, {
    //     variables: {
    //         page: 'whatsapp',
    //         language: 'he',
    //     },
    // });

    let location = useLocation();
    let history = useHistory();
    const taxRefundsEl = useRef(null);
    const contactRef = useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const refReady = () => contactRef.current;

    useEffect(() => {
        const { current } = contactRef;

        if (current && location.hash === '#contact') {
            setTimeout(() => {
                current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }, 1000);
            history.push('/');
        }
    }, [refReady, contactRef, history, location.hash]);

    if (loading) {
        return <HomeContainer>
            <Loader />
        </HomeContainer>;
    }

    if (error) {
        return <HomeContainer>קרתה שגיאה</HomeContainer>;
    }
    const { contentByPage } = data;
    const { top, taxRefunds, insurence, bigCompanies, head } = reduceContent(contentByPage);

    const { title, meta: { description: metaDescription, title: metaTitle, image: metaImage } } = head;

    const { contentByPage: cpg } = d1 || {};
    const { head :hd1 } = cpg ? reduceContent(cpg) : {};

    const { title: tlt1, mobile, desktop } = hd1 || {};

    console.log(tlt1);
    console.log(mobile);
    console.log(desktop);
    const ua = navigator.userAgent;
    let ctaBtnLink = desktop;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
        ctaBtnLink = mobile;
    } else{
        ctaBtnLink = desktop;
    }

    return <HomeContainer>
        <Helmet>
            {!!title && <title>{title.text}</title>}
            {!!metaTitle && <meta name='title' content={metaTitle.text} />}
            {!!metaTitle && <meta name='og:title' content={metaTitle.text} />}
            {!!metaImage && <meta name='og:image' content={`${serverUri}ogImage/home`} />}
            {!!metaDescription && <meta name='description' content={metaDescription.text} />}
            {!!metaDescription && <meta name='og:description' content={metaDescription.text} />}
            {!!metaDescription && <meta name='twitter:description' content={metaDescription.text} />}
        </Helmet>
        <Top
            top={top}
            onClick={() => {
                !!taxRefundsEl.current && taxRefundsEl.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }}
        />
        <TaxRefunds
            ctaBtnTitle={tlt1}
            ctaBtnLink={ctaBtnLink}
            taxRefunds={taxRefunds}
            taxRefundsEl={taxRefundsEl}
        />
        <Insurance insurance={insurence} />
        <ClientTestimonies
            ctaTo='/chatbot/taxrefund'
            ctaBtnTitle={tlt1}
            ctaBtnLink={ctaBtnLink}
        />
        <Articles />
        <BigCompanies bigCompanies={bigCompanies} />
        <BlogSlider />
        <Contact forwardRef={contactRef} />
    </HomeContainer>;
};

export default Home;
